import { ButtonUpsellProtected } from '@components'

import Cookies from 'js-cookie'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { CookieKeys } from '../../../../../../enums/cookieKeys'
import { Scope } from '../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../enums/trackingContext'
import { useSegment } from '../../../../../../hooks'
import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'

export const RecurringInvoicesSideActions = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const navigate = useNavigate()
  const location = useLocation()

  const recurringInvoiceDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.RecurringInvoice)

  const { url: recurringInvoiceNewUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getNewDocumentRoute(recurringInvoiceDocumentRouteBase),
  )

  const handleCreateNewRecurringInvoiceClick = useCallback(() => {
    Cookies.set(CookieKeys.RecurringInvoicesListQuery, location.search)
    track('XXX - Invoicing Core - Recurring invoice editor opened', { triggeredBy: 'create_recurring_invoice_cta' })

    if (recurringInvoiceNewUrl) {
      navigate(recurringInvoiceNewUrl)
    }
  }, [location.search, navigate, recurringInvoiceNewUrl, track])

  return (
    <ButtonUpsellProtected
      icon="circlePlus"
      onClick={handleCreateNewRecurringInvoiceClick}
      upsellScope={Scope.RecurringInvoiceUpsell}
      trackingContext={TrackingContext.CreateRecurringInvoice}
    >
      {t('recurring_invoices.side_actions.create_recurring_invoice')}
    </ButtonUpsellProtected>
  )
}
